export default __webpack_public_path__ + "static/media/gallery-wip-emitter_04.b188bc33.jpg";